import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ApiResult, PageResult } from 'src/app/shared/model/Index';
import { StudentSearchService } from '../services/student-search.service';
import { Router } from '@angular/router';
import { IStudent } from '@app/modules/compliance/model/student';
import { MatSidenav } from '@angular/material/sidenav';
import { IStudentSearchResult, StudentSearchFilter } from '../model/studentSearchResult';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { StudentAthleteService } from '@app/modules/compliance/services/student-athlete.service';
import { fromEvent, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { SortOrder,PAGESIZE, PAGE } from '@app/modules/shared/model/grid-model';
import { AddStudentDialog } from '../dialogs/add-student-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NgxPermissionsService } from 'ngx-permissions';
@Component({
    selector: 'student-search',
    templateUrl: './student-search.component.html',
    styleUrls: ["./student-search.component.scss"]
})
export class StudentSearchComponent implements OnInit, AfterViewInit{
    displayedColumns: string[] = ['institutionId', 'workdayId', 'lastName','firstName','middleName','collegeName', 'primarySport', 'lastSeason'];
    dataSource = new MatTableDataSource<IStudentSearchResult>();    
    student: IStudent;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('input') input: ElementRef;
    studentCount:number;
    disableInput:boolean=false;
    public searchFilter: StudentSearchFilter;
    AddStudent:boolean=false;
    @ViewChild('rightSideNav') rightSideNav: MatSidenav;
    constructor(
        public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        private router: Router,
        private _studentsearchservice: StudentSearchService,
        private _studentathleteservice: StudentAthleteService,
        private _permissionservice: NgxPermissionsService
    ){}

    async ngOnInit() {
        this.searchFilter={
            pageSize:PAGESIZE,
            page:PAGE+1,
            sortDirection:0,
            sortOrderBy:"lastName"
        }
        await this.getPermission();
        this.student=null;
    }
    ngAfterViewInit(): void {        
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        // on sort or paginate events, load a new page
        merge(this.sort.sortChange, this.paginator.page)
        .pipe(
            tap(() =>{ 
                this.searchFilter={
                    pageSize:this.paginator.pageSize,
                    page:this.paginator.pageIndex+1,
                    sortDirection:this.sort.direction === SortOrder.DESC ? 1 : 0,
                    sortOrderBy:this.sort.active,
                    name:this.input.nativeElement.value
                }
                this.getStudents()
            })
        )
        .subscribe();
    } 

    search()
    {
        this.paginator.pageIndex = 0;
            this.searchFilter={
                pageSize:this.paginator.pageSize,
                page:this.paginator.pageIndex+1,
                sortDirection:this.sort.direction === SortOrder.DESC ? 1 : 0,
                sortOrderBy:this.sort.active,
                name:this.input.nativeElement.value
            }
            this.getStudents();
    }

    getStudents() {
        this.disableInput =true;   
        this._studentsearchservice.studentSearch(this.searchFilter).
        subscribe((result: ApiResult<PageResult<IStudentSearchResult>>) =>
        {
            this.disableInput=false;
            if (result.validationErrors === null && result.value !== null) {
                this.dataSource = new MatTableDataSource(result.value.items);
                this.studentCount=result.value.count;                
            }
            setTimeout(() => {
                document.getElementById('txtSearch').focus();
            }, 300);
        }, error => console.error(error));
    }  
    
    view(model: IStudentSearchResult) {  
        this._studentathleteservice.get(model.studentId).subscribe((result: ApiResult<IStudent>) => {
            if (result.validationErrors == null && result.value != null) {
                this.student = result.value;      
                this.rightSideNav.toggle();            
            }
        }, error => console.error(error));
    }    
    
    openDialog() {
        const dialogRef = this.dialog.open(AddStudentDialog, {
            width: '40%',
            data: {  },
            backdropClass: 'backdropBackground'
        });
        dialogRef.afterClosed().subscribe(result => {
        });
    }

    async getPermission() {
        this._permissionservice.hasPermission("add:student").then(data=>{
            this.AddStudent=data;
        }); 
    }
}
